export default __webpack_public_path__ + "static/media/xpo-lev.6fa17a48.svg";